import BrandingBadges from 'components/layout/branding-badges';
import {
  BreadcrumbLink,
  Separator
} from 'components/layout/breadcrumb-elements';
import { findAdminTabContext } from 'utils/admin-tabs';

type Props = {
  activeTabIndex: number;
};

export default function AdminBreadcrumbBar({ activeTabIndex }: Props) {
  const context = findAdminTabContext(activeTabIndex);

  return (
    <div className='flex h-8 w-full shrink-0 items-center gap-1 bg-neutral-900 px-4 text-xs text-white'>
      {context && (
        <>
          <BreadcrumbLink label={context.groupLabel} />
          <Separator />
          <BreadcrumbLink label={context.tabName} />
        </>
      )}
      <BrandingBadges
        trailingBadge={
          <span className='rounded-full bg-red-500/30 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-red-400'>
            Admin
          </span>
        }
      />
    </div>
  );
}
